import { render, staticRenderFns } from "./JdsPageTitle.vue?vue&type=template&id=46c5330e&scoped=true&"
import script from "./JdsPageTitle.vue?vue&type=script&lang=ts&"
export * from "./JdsPageTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5330e",
  null
  
)

export default component.exports